/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Area_AllInputs */

const vi_my_grower_report_area_all = /** @type {(inputs: My_Grower_Report_Area_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả bãi`)
};

/**

* @param {My_Grower_Report_Area_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_area_all = /** @type {((inputs?: My_Grower_Report_Area_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Area_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_area_all(inputs)
});